module.exports = __webpack_public_path__ + "img/videowiki-cast.066fae6f.svg";